import React from 'react';
import { Container } from 'react-bootstrap';
import './Privacy.css';

const PrivacyPolicy = () => {
  return (
    <Container className="home-page-wrapper">
      <h6>PRIVACY POLICY</h6>
      <p>Effective Date: Nov 23, 2024</p>

      <p>
        Sunthar (“we,” “us,” or “our”) respects your privacy and is committed to protecting the information you share with us.
        This Privacy Policy describes how we collect, use, and share your information when you use Sunthar.com (“Platform”).
        By using the Platform, you consent to the practices described in this Privacy Policy.
      </p>

      <ol className="terms-list">
        <li>
          <strong>Information We Collect</strong>
          <ul>
            <li>
              <strong>Email Address:</strong> We collect your email address when you log in via Google for authentication purposes.
            </li>
            <li>
              <strong>Name:</strong> Your Gmail display name is collected to personalize your experience.
            </li>
            <li>
              <strong>Analytics Data:</strong> We collect non-identifiable analytics data, such as device type, browser information, and usage patterns,
              to improve the Platform. We do not use third-party analytics services, and we do not collect your IP address.
            </li>
            <li>
              <strong>Error and Crash Reporting:</strong> We use Sentry to collect information about application crashes for debugging purposes.
              Personal identifiable information (PII) is not collected.
            </li>
          </ul>
        </li>

        <li>
          <strong>How We Use Your Information</strong>
          <ul>
            <li>To provide and improve our services.</li>
            <li>To authenticate users and maintain platform security.</li>
            <li>To communicate with you regarding your account and support requests.</li>
            <li>To analyze usage trends and enhance the user experience.</li>
          </ul>
        </li>

        <li>
          <strong>How We Share Your Information</strong>
          <ul className="nested-list">
            <li>
              <strong>Third-Party Services:</strong>
              <ul>
                <li>We use Sentry for crash reporting. Only necessary data for debugging purposes is shared, excluding PII.</li>
                <li>We use Stripe for processing payments. All transaction-related data is handled according to Stripe’s Privacy Policy.
                  Please refer to <a href="https://stripe.com/en-ca/privacy" target="_blank" rel="noopener noreferrer">Stripe’s Privacy Policy</a> for details.</li>
              </ul>
            </li>
            <li>
              <strong>Legal Requirements:</strong>
              <ul>
                <li>We may disclose your information if required by law or to protect our rights, property, or safety.</li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          <strong>Data Storage and Security</strong>
          <p>
            We implement industry-standard security measures to protect your data. Sunthar.com uses TLS encryption site-wide, and all stored data is encrypted using AES-256 encryption.
          </p>
        </li>

        <li>
          <strong>Your Rights and Choices</strong>
          <p>
            You may request updates or deletion of your data by contacting us at <a href="mailto:support@sunthar.com">support@sunthar.com</a>.
            Some data may be retained for legal or operational purposes.
          </p>
        </li>

        <li>
          <strong>Changes to This Privacy Policy</strong>
          <p>
            We may update this Privacy Policy periodically. Continued use of the Platform constitutes acceptance of the revised policy.
          </p>
        </li>

        <li>
          <strong>Contact Us</strong>
          <p>
            If you have any questions or concerns, contact us at <a href="mailto:support@sunthar.com">support@sunthar.com</a>.
          </p>
        </li>
      </ol>
    </Container>
  );
};

export default PrivacyPolicy;
